import { Button, makeStyles } from "@material-ui/core"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { RouteAdminUser } from "../../Admin/constant/routesName"

export function SuccessPayment() {
    const classes = styles()
    const { t } = useTranslation<'common'>()

    return <div className={classes.container}>
        <p className={classes.check}>✅</p>
        <p className={classes.text}>{t('label.success-paiment.paiment-reussi')} 👍</p>
        <Link to={`${RouteAdminUser.BOOKING}`} className={classes.linkContainerButton}>
            <Button className={classes.go}>
                {t('paiement.label.voir-mes-reservations')}
            </Button>
        </Link>
    </div>
}

const styles = makeStyles(() => ({
    container: {
        width: '100%',
        height: '50vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '20px 0'
    },
    check: {
        fontSize: '36px',
    },
    text: {
        fontSize: '24px'
    },
    linkContainerButton: {
        textDecoration: 'none'
    },
    go: {
        fontSize: 14,
        fontFamily: "Josefin Sans",
        color: "#FFFFFF",
        textTransform: "capitalize",
        textAlign: "center",
        padding: "8px 14px",
        borderRadius: 100,
        background: "#890608",
        marginTop: 20,
        "&:hover": {
            background: "#B5551B",
        },
    },
}))